import graphql__fdbbfef8d39ea58a2d58 from "./__generated__/PageSectionCookiesConsentsConfiguration_pageSection.graphql.js";import { useState } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector, useDispatch } from "react-redux";
import { defineMessages } from "react-intl";

import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import OptionInput from "../Input/OptionInput";
import Icon from "../Utils/Icon";
import { useFormatMessage } from "../Intl/Context";
import { sendToMatomo } from "../Utils/useMatomoTracking";

import { updateViewer } from "../../reducers/viewer";
import { storeViewerCookiesConsentment } from "../../mutations/StoreViewerCookiesConsentmentMutation";

const PageSectionCookiesConsentsConfiguration = props => {
  const pageSection = useFragment(
    PageSectionCookiesConsentsConfiguration_pageSection,
    props.pageSection
  );
  const { title, description, iconClass, defaultAcceptsCookiesValue } = pageSection;
  // Cast `null` to the `defaultAcceptsCookiesValue` value, as the null value means that
  // the user didn't already make a choice, and depending on the configuration of the
  // platform it could imply that the user is either tracked or not.
  const acceptsCookies = useSelector(({ viewer }) =>
    viewer.acceptsCookies !== null ? viewer.acceptsCookies : defaultAcceptsCookiesValue
  );

  const t = useFormatMessage();
  const consentToMatomo = t(intlMessages.consentToMatomo);

  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const handleCheckBoxClicked = ({ target }) => {
    const { checked } = target;

    if (isLoading || checked === acceptsCookies) return;

    setIsLoading(true);

    storeViewerCookiesConsentment(checked, ({ storeViewerCookiesConsentment }) => {
      dispatch(updateViewer(storeViewerCookiesConsentment.viewer));
      setIsLoading(false);

      const matomoAction = checked ? "rememberConsentGiven" : "forgetConsentGiven";

      sendToMatomo(matomoAction);
    });
  };

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName={iconClass}
      className="container box"
    >
      {!isLoading && (
        <OptionInput
          type="checkbox"
          name="acceptsCookies"
          option={{ id: "acceptsCookies", name: consentToMatomo }}
          checked={acceptsCookies}
          onChange={handleCheckBoxClicked}
        />
      )}

      {isLoading && (
        <div className="form-check">
          <div className="form-check-label">
            <div className="form-check-label-inner">
              <Icon className="fa fa-circle-notch fa-spin" />
            </div>
          </div>
        </div>
      )}
    </PageSectionBlockWithTitleAndDescription>
  );
};

const PageSectionCookiesConsentsConfiguration_pageSection = graphql__fdbbfef8d39ea58a2d58;

export default PageSectionCookiesConsentsConfiguration;

const intlMessages = defineMessages({
  consentToMatomo: {
    id: "cookiesConsentsConfiguration.consentToMatomo",
    defaultMessage: `
      J'autorise les cookies tiers de l'application Matomo afin de permettre l'analyse du
      traffic sur la plateforme
    `
  }
});
